/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FieldWrapper, Field } from '../../../styles';

function InputField({ name, label, disabled, small, coupon, renderError = () => {}, ...props }) {
  const { t } = useTranslation();
  const { register, errors } = useFormContext();

  const labelText = label || t(`publisher.step4.module2.field.${name}.label`);
  const placeholder = t(`publisher.step4.module2.field.${name}.placeholder`);

  return (
    <FieldWrapper small={small} coupon={coupon} disabled={disabled}>
      <label htmlFor={name}>{labelText}</label>
      <Field
        as='input'
        ref={register}
        error={!!errors[name]}
        name={name}
        placeholder={placeholder}
        id={name}
        data-checkout={name}
        disabled={disabled}
        coupon={coupon}
        {...props}
      />
      {renderError({ name, errors })}
    </FieldWrapper>
  );
}

export { InputField };
